var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "close-on-content-click": false,
        transition: "scale-transition",
        "offset-y": "",
        "min-width": "290px",
        disabled: _vm.disabled,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c(
                "v-text-field",
                _vm._g(
                  {
                    attrs: {
                      label: _vm.label,
                      "prepend-icon": "event",
                      readonly: "",
                      "hide-details": "",
                      disabled: _vm.disabled,
                    },
                    model: {
                      value: _vm.stringDate,
                      callback: function ($$v) {
                        _vm.stringDate = $$v
                      },
                      expression: "stringDate",
                    },
                  },
                  on
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _c("v-date-picker", {
        attrs: { min: _vm.minDate, "no-title": "", disabled: _vm.disabled },
        on: {
          input: function ($event) {
            _vm.menu = false
          },
        },
        model: {
          value: _vm.date,
          callback: function ($$v) {
            _vm.date = $$v
          },
          expression: "date",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }